function highlightPlugin(jq) {
  jq.fn.highlight = function () {
    jq(this).each(function () {
      var el = jq(this);
      jq('<div/>')
        .width(el.outerWidth())
        .height(el.outerHeight())
        .css({
          'position': 'absolute',
          'left': el.offset().left,
          'top': el.offset().top,
          'background-color': '#ffff99',
          'opacity': '.7',
          'z-index': '9999999'
        }).appendTo('body').fadeOut(1000).queue(function () { jq(this).remove(); });
    });
  };
}

// Rejestruj na npm-jQuery (Vite inject) i CDN-jQuery (window.jQuery).
// JS odpowiedzi Rails UJS wykonuje się przez window.$ (CDN jQuery) -
// bez rejestracji na obu instancjach $.fn.highlight nie istnieje w CDN kontekście.
highlightPlugin(jQuery);
if (window.jQuery && window.jQuery !== jQuery) {
  highlightPlugin(window.jQuery);
}
